module.exports = __webpack_public_path__ + "img/a2.5c2caf45.png";